import CardOptionWrapper from '../card_option_wrapper/element.js';
import translations from './translations.js';
import style from './style.lit.css';

/**
 * Wrapper of poll options
 *
 * 1. It expects options to be passed via `<ef-poll-option>`.
 * 2. If one option contradicts others add this property to it: `isRadio="true"`.
 * 3. Don't pass the `percent` to `<ef-poll-option>`, instead just pass the `amount` of votes and let the component calculate the `percent`.
 */

export default class PollOptionWrapper extends CardOptionWrapper {
  static styles = [CardOptionWrapper.styles, style];

  /** @internal */
  static translations = translations;

  /** @internal */
  get options() {
    return Array.from(this.querySelectorAll('ef-poll-option'));
  }

  handleSlotChange() {
    const totalVotes = this.calcTotalVotes();

    this.options.forEach(o => {
      o.disabled ||= this.isClosed;
      o.AppConfig = this.AppConfig;
      o.percent = totalVotes === 0 ? 0 : (o.amount * 100) / totalVotes;
    });
  }

  handleInput(e) {
    const { target } = e;
    const checked = target.checked;

    if (checked && this.checkedCount === 1) this.totalCount++;
    else if (!checked && this.checkedCount === 0) this.totalCount--;

    if (checked) this.handleRadioOptions(target);

    // totalVotes can be different from this.totalCount if any options are not *unique* (radio options - they cancel others out).
    const totalVotes = this.calcTotalVotes();
    this.options.forEach(
      o => (o.percent = totalVotes === 0 ? 0 : (o.amount * 100) / totalVotes)
    );
  }

  calcTotalVotes() {
    let total = 0;
    this.options.forEach(o => (total += o.amount));
    return total;
  }
}

PollOptionWrapper.registerTagName('ef-poll-option-wrapper');

customElements.get('ef-poll-option-wrapper') ||
  customElements.define('ef-poll-option-wrapper', PollOptionWrapper);
